import axios from "axios";
import Vue from 'vue'
import VueToast from 'vue-toast-notification'

Vue.use(VueToast);

let Api = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
});

Api.interceptors.response.use(
    function(response){  
        if(response.status == 204){
					if(response.config.url != '/csrf-cookie'){
						let text = '';
						if(response.config.method == 'delete'){
							text = 'Sikeres törlés';
						}else{
							text = 'Sikeres bejelentkezés';
						}
						Vue.$toast.open({
								message: text,
								type: 'success',
								position: 'top', 
						});
					}
        }
        if(response.status == 201){
            Vue.$toast.open({
                message: 'Sikeres létrehozás',
                type: 'success',
                position: 'top', 
            });
        }
        if(response.status == 202){
            Vue.$toast.open({
                message: 'A művelet sikeres volt',
                type: 'success',
                position: 'top', 
            });
        }
        
        return response;
    },
    function(error) {
        if(error.response.status == 401 || error.response.status == 419){  
			localStorage.removeItem("auth");
            localStorage.removeItem("user");
            top.location.reload();
            return new Promise(() => { });            
        }
        else if(error.response.status == 404){
            Vue.$toast.open({
                message: error.response.data.message,
                type: 'error',
                position: 'top', 
            }) 
            return new Promise(() => { });            
        }
        else if(error.response.status == 422){

            let error_keys = Object.keys(error.response.data.errors)

            if(error_keys.length == 1){            
                Vue.$toast.open({
                    message: error.response.data.errors[error_keys[0]][0],
                    type: 'error',
                    position: 'top', 
                })                        
                //return new Promise(() => { });            
                throw error;
            }
            else{
                throw error;
            }        
        }
        else if(error.response.status == 500){
            Vue.$toast.open({
                message: 'Homokszem került a gépezetbe!',
                type: 'error',
                position: 'top', 
            })
            return new Promise(() => { });            
        }
    }   
);

Api.defaults.withCredentials = true;

export default Api;